import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { InControlDetail } from './InControlDetail';

export class InControlDetailsResource extends FBaseService {
  public async getCyclesForAccount(fiId: string, akk: string): Promise<number[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/incontrol-details/cycles/${akk}`,

    );
    const results: number[] = response.data.data;
    return results;
  }

  public async getInControlDetail(fiId: string, cycleId: number, externalProductMappingId: string, akk: string)
    : Promise<InControlDetail> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/incontrol-details/by-key/${cycleId}/${externalProductMappingId}/${akk}`,
    );
    const results: InControlDetail = response.data.data;
    return results;
  }
}

export default InControlDetailsResource;
